// A short public source is an entry address, never a legacy checkout token.
// Use the existing PHP endpoint when the web server serves this path as SPA.
export const qrPublicEntryTarget = (pathname, search = '') => {
    const match = String(pathname || '').match(/^(\/(?:orderpro\/)?(?:qr|nfc)|\/orderpro)?\/([A-Za-z0-9_-]{43})\/?$/);
    if (!match) return null;
    const root = match[1] || '';
    const key = match[2];
    const queryKeys = new URLSearchParams(search).getAll('k');
    if (queryKeys.length > 1 || (queryKeys.length === 1 && queryKeys[0] !== key)) return `${root}/invalid_qr`;
    return `${root}/entry.php?k=${key}`;
};
export const replaceQrEntryLocation = target => window.location.replace(target);
